<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="12" sm="12">
        <v-card>
          <v-card-title>Статистика операторов по проектам</v-card-title>

          <!-- Селекторы -->
          <v-form ref="form" class="mb-n1">
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="6" md="4" lg="4" xl="2">
                  <date-time-picker v-model="filters.date" />
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="4" xl="2">
                  <ProjectSelector v-model="filters.projects" />
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="4" xl="2">
                  <CampaignSelector v-model="filters.campaigns" no-rules :projectIds="filters.projects" :disabled.sync="disableCampaignSelector" />
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="4" xl="2">
                  <QueueSelector v-model="filters.queues" no-rules :projectIds="filters.projects" />
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="4" xl="2">
                  <GroupSelector noRules v-model="groups" @change:users="filters.users = $event" />
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="4" xl="2">
                  <UserSelector v-model="filters.users" />
                </v-col>


                <v-col cols="12" sm="12" md="4" lg="12" align="right" class="mt-auto">
                  <v-btn color="success" @click="loadReport" style="margin-top:13px;">Поиск</v-btn>
                </v-col>

              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
    </v-row>

    <v-expansion-panels v-model="expansion" class="mt-4" hover :value="0">

      <!-- Общая статистика -->
      <v-expansion-panel class="mb-2">
        <v-expansion-panel-header>Общая статистика</v-expansion-panel-header>

        <v-expansion-panel-content class="expansion-zero-padding">
          <v-data-table
            :headers="reportTotal.headers"
            :items="reportTotal.items"
            :items-per-page="reportTotal.items.length"
            :loading="loading"
            item-key="uid"
            loading-text="Загрузка..."
            no-data-text="Ничего не найдено"
            hide-default-footer
            dense
          />
        </v-expansion-panel-content>
      </v-expansion-panel>

      <!-- Статистика по проектам -->
      <v-expansion-panel>
        <v-expansion-panel-header>Отчёт</v-expansion-panel-header>

        <v-expansion-panel-content class="expansion-zero-padding">
          <v-data-table
            :headers="report.headers"
            :items="report.items"
            :items-per-page="report.items.length"
            :loading="loading"
            show-group-by
            group-by="project_name"
            loading-text="Загрузка..."
            no-data-text="Ничего не найдено"
            hide-default-footer
            dense
          >
            <template #group.header="options">
              <td class="text-start" :colspan="options.headers.length">
                <v-btn small icon @click="options.toggle">
                  <v-icon>mdi-minus</v-icon>
                </v-btn>
                <span>Проект: {{ options.group }}</span>
                <v-btn small icon @click="options.remove">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>


<script>
import CampaignSelector from '~/components/partials/selectors/CampaignSelector.vue'
import GroupSelector from '~/components/partials/selectors/GroupSelector.vue'
import UserSelector from '~/components/partials/selectors/UserSelector.vue'
import ProjectSelector from '~/components/partials/selectors/ProjectSelector.vue'
import QueueSelector from '~/components/partials/selectors/QueueSelector.vue'
import { mapActions } from 'vuex'
import { axios } from "~/plugins/axios"
import moment from 'moment'

export default {
  components: {
    GroupSelector,
    UserSelector,
    CampaignSelector,
    ProjectSelector,
    QueueSelector,
  },
  name: 'OperatorsByProjects',
  data() {
    return {
      expansion: null, // 0 - Общая статистика | 1 - Отчёт
      filters: {
        date: {},
        projects: [],
        campaigns: [],
        queues: [],
        users: [],
      },
      disableCampaignSelector: true,
      groups: [],

      reportTotal: {
        headers: [
          {text: 'Оператор', value: 'user_name', },
          {text: 'Количество вызовов', value: 'total_calls_count', },
          {text: 'Общее время разговора, посекундная тарификация', value: 'total_duration_in_sec', },
          {text: 'Общее время разговора, поминутная тарификация', value: 'total_duration_in_min', },
          {text: 'Результативное время разговора, посекундная тарификация', value: 'outbound_duration_in_sec', },
          {text: 'Результативное время разговора, поминутная тарификация', value: 'outbound_duration_in_min', },
        ],
        items: [],
      },
      report: {
        headers: [
          {text: 'Проект', value: 'project_name', },
          {text: 'Оператор', value: 'user_name', groupable: false },
          {text: 'Количество вызовов', value: 'total_calls_count', groupable: false },
          {text: 'Общее время разговора, посекундная тарификация', value: 'total_duration_in_sec', groupable: false },
          {text: 'Общее время разговора, поминутная тарификация', value: 'total_duration_in_min', groupable: false },
          {text: 'Результативное время разговора, посекундная тарификация', value: 'outbound_duration_in_sec', groupable: false },
          {text: 'Результативное время разговора, поминутная тарификация', value: 'outbound_duration_in_min', groupable: false },
        ],
        items: [],
      },
      loading: false,
    }
  },

  methods: {
    ...mapActions({
      setError: 'shared/setError',
    }),


    async loadReport() {
      if (!this.$refs.form.validate()) return

      this.$store.commit('shared/SET_LOADING', true, {root: true});
      this.loading = true

      this.report.items.length = 0
      this.reportTotal.items.length = 0

      try {
        const payload = {
          period: [
            moment(this.filters.date.start).format('YYYY-MM-DD HH:mm:ss'),
            moment(this.filters.date.end).format('YYYY-MM-DD HH:mm:ss')
          ],
          ...this.filters
        }

        const response = await axios.post('/api/reports/outbound-statistics-operator-by-projects', payload)
        const data = response.data

        this.reportTotal.items = data.total_stats
        this.report.items = data.statistic
        this.expansion = 1
      } catch (error) {
        let payload = { message: error }
        if (error?.response?.data) payload = error.response.data.data
        this.setError(payload)
      } finally {
        this.loading = false
        this.$store.commit('shared/SET_LOADING', false, {root: true});
      }
    },
  },
}
</script>


<style scoped lang="scss">
.expansion-zero-padding > div {
  padding: 0 !important;
}
</style>